import React from 'react';
import './RightPanel.css';

function RightPanel({ isOpen, onClose }) {
    if (!isOpen) {
        return null;
    }

    return (
        <>
            <div className="right-panel-overlay" onClick={onClose}></div>

            <div className="right-panel open">
                <div className="right-panel-header">
                    <h3>Sign In</h3>
                    <button className="close-btn" onClick={onClose}>
                        <i className="fa-solid fa-times"></i>
                    </button>
                </div>

                <div className="right-panel-content">
                    <div className="sign-in-card">
                        <div className="sign-in-methods">
                            <button className="btn-oauth google">
                                <i className="fa-brands fa-google"></i>
                                Use Google
                            </button>
                            <button className="btn-oauth apple">
                                <i className="fa-brands fa-apple"></i>
                                Use Apple
                            </button>
                        </div>

                        <div className="divider-text">
                            <span>OR</span>
                        </div>

                        <form className="sign-in-form">
                            <div className="form-group">
                                <label>Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="email@company.com"
                                />
                            </div>

                            <div className="form-group">
                                <label>Password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="••••••••"
                                />
                            </div>

                            <div className="form-options">
                                <label className="checkbox-label">
                                    <input type="checkbox" />
                                    <span>Remember me</span>
                                </label>
                                <a href="/forgot-password" className="link">Forgot Password?</a>
                            </div>

                            <button type="submit" className="btn-submit">
                                Sign In
                            </button>
                        </form>

                        <div className="sign-up-link">
                            <p>Don't have an account? <a href="/register">Sign up</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RightPanel;
